import React from 'react';

const LoadingSpinner = () => {
  return <div className="spinner-border m-3" role="status"></div>;
};

export default LoadingSpinner;
